export default __webpack_public_path__ + "img/eVCdYgxp.aba27f6f.svg";